import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
import { initMetaPixel } from "./utils/metaPixel";
export function App() {
  useEffect(() => {
    document.title = "New Manager Essentials | 10 Workshop Plans + 5 Bonuses";
    document.documentElement.lang = "en";
    const metas = [["name", "description", "Lead practical manager training with 10 workshop plans, facilitator scripts, printable worksheets, and 5 bonuses. English-language digital kit. $27 USD, one time."], ["property", "og:title", "New Manager Essentials | Workshop Kit"], ["property", "og:description", "Your next manager workshop, with a clear plan. 10 workshops + 5 bonuses. $27 USD."], ["property", "og:url", "https://managers.stockdigital.shop/"], ["name", "twitter:title", "New Manager Essentials | Workshop Kit"], ["name", "twitter:description", "10 workshop plans, practical activities, and 5 bonuses. $27 USD."]];
    metas.forEach(([attribute, key, value]) => {
      let meta = document.querySelector('meta[' + attribute + '="' + key + '"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, key);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", value);
    });
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://managers.stockdigital.shop/");
    initMetaPixel();
  }, []);
  return <Landing data-id="element-0" data-mp="33movnqc0akp0" />;
}